var map = {
	"./en-US/index.js": 78219,
	"./en-US/notice.js": 91707,
	"./en-US/pages.js": 11303,
	"./vi/index.js": 97650,
	"./vi/notice.js": 8000,
	"./vi/pages.js": 23458,
	"./zh-CN/index.js": 55765,
	"./zh-CN/notice.js": 61737,
	"./zh-CN/pages.js": 71709,
	"./zh-TW/index.js": 49537,
	"./zh-TW/notice.js": 40677,
	"./zh-TW/pages.js": 4961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22329;